// MapLogoIcon.js
import React from 'react';

const NotificationLogoIcon = ({ isActive }) => {
  return (
    <img
      src={isActive?require('../../assets/Images/blue-notification.png'):require('../../assets/Images/notification.png')}
      alt="map-logo"
      height={16}
      width={16}
      style={{
        backgroundColor: "white",
        verticalAlign: "middle",
        display: "inline-block",
        marginRight: "10px",
        marginBottom: "2px",
      }}
    />
  );
};

export default NotificationLogoIcon;
